import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { routePaths } from '@constants/index';
import { SessionService } from './session.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  private publicRoutes = [
    routePaths.root,
    routePaths.login,
    routePaths.signup,
    routePaths.verifyEmail,
    routePaths.forgotPassword,
    routePaths.emailVerified,
    routePaths.resetPassword
  ];
  constructor(private sessionService: SessionService, private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentPath = state.url.split('/')[1].split('?')[0];
    if (this.sessionService.isAuthenticate()) {
      this.adminRedirectHandler(currentPath);
      if (this.isPublicRoute(currentPath)) {
        this.router.navigateByUrl(routePaths.dashboard);
        return false;
      }
      return true;
    } else {
      if (!this.isPublicRoute(currentPath)) {
        this.router.navigateByUrl(routePaths.login);
        return false;
      }
      return true;
    }
  }

  private isPublicRoute(route): boolean {
    return this.publicRoutes.indexOf(route) > -1;
  }
  private adminRedirectHandler(currentPath: string): void {
    if (currentPath !== routePaths.admin && this.sessionService.isAdmin()) {
      this.router.navigateByUrl(routePaths.admin);
    }
  }
}
